<template>
<div>
  <v-layout>
    <v-flex xs12 style="position:relative">
      <v-text-field v-if="editable" v-model="model" :landscape="true"></v-text-field>
      <div v-else>
        <span v-if="isBaseValid()">
          {{ getCustomPresentationValue(model) }}
        </span>
        <!-- Invalidate or advanced validtaor -->
        <v-tooltip v-else top>
          <template v-slot:activator=" { on }">
            <span ref="span" v-on="on">{{ getCustomPresentationValue(model) | notEmpty }}</span>
          </template>
          <span>{{ validation.message }}</span>
        </v-tooltip>
      </div>
      <v-icon v-if="isEdited() && editable" class="light-green--text form-field__icon--update" @click="updateOrigin">
        check
      </v-icon>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import {input} from '@/mixins/input'
import NumberValidator from '@/plugins/validator/number/NumberValidator'

export default {
  mixins: [input],
  props: ["valueField", "editable", "field", "validation", "context"],
  data() {
    return {
      modelx: "",
      valueToShow: ""
    }
  },
  computed: {
    locale: () => process.env.VUE_APP_LOCALE
  },
  watch: {
    editable: function(newVal) {
      if (!newVal && this.isEdited())
        this.reset();
    },
    valueField: function(newVal) {
      this.valueToShow = newVal
      this.model = this.setUpModel(newVal)
    }
  },
  created() {
    this.model = this.setUpModel(this.valueField)
    this.valueToShow = this.valueField
  },
  mounted() {
    if ((this.field.type == "number" || this.field.type == "formule") && this.field.options && this.field.options.expanded) {
      let x = new NumberValidator(this.field, this.context, this.$refs.span)
      x.matchAndValidate()
    }
  },
  methods: {
    isBaseValid() {
      if (this.field.options && this.field.options.expanded)
        return false;
      return this.validation.pass
    },
    setUpModel(value) {
      return value
    },
    updateOrigin() {
      this.$emit("updateField", this.model)
    },
    isEdited() {
      return this.valueField != this.model
    },
    reset() {
      this.model = this.setUpModel(this.valueField)
    },
    getCustomPresentationValue(model) {
      if (this.canBeFormatetToDecimal(model)) {
        return Number(model).toFixed(this.field.options.fixed)
      }
      return model;
    },
    canBeFormatetToDecimal(model) {
      if (model != undefined && this.field.options != undefined && this.field.type == "number" && this.field.options.fixed != undefined) {
        return true;
      }
      return false;
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/main.scss";
</style>